import {
  EXCHANGE_SPORTS_ROUTE,
  fetchDateRangeEvent,
  fetchEventsBySport,
  fetchInplayEvent, getExchangeEvents, getUpcomingEvents,
  GREYHOUND_ROUTE,
  HORSE_RACE_ROUTE,
  IN_PLAY_ROUTE,
  MULTI_MARKETS_ROUTE,
  SPToBFIdMap,
  useAppDispatch, useAppSelector
} from "@hypexone/uicore";
import moment from "moment";
import { lazy, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import MultiMarketView from "../view/components/multi-market/MultiMarketView";
import HorseRacing from "../view/pages/HorseRacing";
import Casino from "../view/pages/Casino";
import { isDesktop } from "react-device-detect";

const EventsPage = lazy(() => import("../view/pages/EventsPage"));

const SportsLayout = () => {
  const [activeTab, setActiveTab] = useState('inPlay');
  const pathName = useLocation().pathname;
  const pathParams = useParams();

  const dispatch = useAppDispatch();
  const { events: catalogEvents, selectedEventType } = useAppSelector(
    (state) => state.catalog
  );

  const isHorseOrGreyhoundRacingRoute =
    pathName === `${EXCHANGE_SPORTS_ROUTE}${HORSE_RACE_ROUTE}` ||
    pathName === `${EXCHANGE_SPORTS_ROUTE}${GREYHOUND_ROUTE}`;
  const isSportsCasinoRoute = pathName === "/sports_events/casino";

  const isMultiMarketRoute =
    pathName === `${EXCHANGE_SPORTS_ROUTE}${MULTI_MARKETS_ROUTE}`;

  const isInplayRoute = pathName === `${IN_PLAY_ROUTE}`;

  const events = getExchangeEvents(
    catalogEvents,
    SPToBFIdMap[selectedEventType?.id]
      ? SPToBFIdMap[selectedEventType?.id]
      : selectedEventType?.id
  );
  const events_upcoming = getUpcomingEvents(
    catalogEvents,
    SPToBFIdMap[selectedEventType?.id]
      ? SPToBFIdMap[selectedEventType?.id]
      : selectedEventType?.id
  );

  const updateEvent = () => {
    if (!pathParams["competition"]) {
      if (isInplayRoute) {
        dispatch(fetchInplayEvent());
      } else {
        dispatch(
          fetchEventsBySport({
            sportId: SPToBFIdMap[selectedEventType?.id]
              ? SPToBFIdMap[selectedEventType?.id]
              : selectedEventType?.id,
            events: events,
          })
        );
      }
    }
  };
  const updateUpcomingEvent = () => {
    if (!pathParams["competition"]) {
      if (isInplayRoute) {
        const startDate = moment().toISOString();
        const endDate = moment().add(3, 'd').toISOString();
        dispatch(fetchDateRangeEvent({ startDate, endDate }));
      } else {
        dispatch(
          fetchEventsBySport({
            sportId: SPToBFIdMap[selectedEventType?.id]
              ? SPToBFIdMap[selectedEventType?.id]
              : selectedEventType?.id,
            events: events_upcoming as unknown as any,
          })
        );
      }
    }
  };

  useEffect(() => {
    if (activeTab == "inPlay") {
      updateEvent();
    } else {
      updateUpcomingEvent();
    }
  }, [selectedEventType, isInplayRoute, activeTab]);

  useEffect(() => {
    let refreshInterval = setInterval(() => {
      updateEvent();
    }, 60 * 1000);
    return () => {
      clearInterval(refreshInterval);
    };
  }, []);

  return isHorseOrGreyhoundRacingRoute ? (
    <>
      <HorseRacing />
      {isDesktop && (
        <>
          <div className="h-[1px] mt-10 bg-black3 mx-2" />

          <div className="flex flex-wrap mt-3 font-sans justify-center w-full text-[14px]  text-black  text-center gap-y-2">
            <span className="cursor-pointer text-right px-3">
              Privacy Policy
            </span>
            <span className="border-l border-black2 px-3 cursor-pointer text-right">
              Terms And Conditions
            </span>
            <span className="border-l border-black2 px-3 cursor-pointer text-left">
              Rules And Regulations
            </span>
            <span className="border-l border-black2 px-3 cursor-pointer">
              About Us
            </span>
            <span className="border-l border-black2 px-3 cursor-pointer">
              Responsible Gaming
            </span>
          </div>
        </>
      )}
    </>
  ) : isMultiMarketRoute ? (
    <MultiMarketView />
  ) : isSportsCasinoRoute ? (
    <></>
    // <Casino />
  ) : (
    <>
      <EventsPage events={events} activeTab={activeTab} setActiveTab={setActiveTab} />
      {isDesktop && (
        <>
          <div className="h-[1px] mt-10 bg-black3 mx-2" />

          <div className="flex flex-wrap mt-3 font-sans justify-center w-full text-[14px]  text-black  text-center gap-y-2">
            <span className="cursor-pointer text-right px-3">
              Privacy Policy
            </span>
            <span className="border-l border-black2 px-3 cursor-pointer text-right">
              Terms And Conditions
            </span>
            <span className="border-l border-black2 px-3 cursor-pointer text-left">
              Rules And Regulations
            </span>
            <span className="border-l border-black2 px-3 cursor-pointer">
              About Us
            </span>
            <span className="border-l border-black2 px-3 cursor-pointer">
              Responsible Gaming
            </span>
          </div>
        </>
      )}
    </>
  );

};

export default SportsLayout;
